<script setup lang="ts">
import { ref } from 'vue';
import MarqueeContent from './MarqueeContent.vue';

defineProps<{
	announcements: string[];
}>();

const announcementContainer = ref();
</script>

<template>
	<div class="w-full mt-4 bg-gray-950 block sm:block md:block lg:block">
		<div
			ref="announcementContainer"
			class="overflow-hidden h-auto min-h-[40px] relative flex items-center"
		>
			<div
				class="flex w-full overflow-hidden relative h-full font-sans text-[12.8px] leading-[19.2px] font-medium pt-[11.2px] pb-[11.2px] text-white whitespace-nowrap"
			>
				<MarqueeContent :announcements="announcements" />
				<MarqueeContent :announcements="announcements" aria-hidden="true" />
			</div>
		</div>
	</div>
</template>
